import { render, staticRenderFns } from "./modal-template.vue?vue&type=template&id=73839895"
import script from "./modal-template.vue?vue&type=script&lang=ts"
export * from "./modal-template.vue?vue&type=script&lang=ts"
import style0 from "./modal-template.vue?vue&type=style&index=0&id=73839895&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73839895')) {
      api.createRecord('73839895', component.options)
    } else {
      api.reload('73839895', component.options)
    }
    module.hot.accept("./modal-template.vue?vue&type=template&id=73839895", function () {
      api.rerender('73839895', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/modal-template.vue"
export default component.exports